import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CardMaster from 'components/Product/CardMaster';
import ProductMediumsIcon from 'components/Product/ProductMediumsDisplay';
import ProductPriceRangeDisplay from 'components/Product/ProductPriceRangeDisplay';
import { getCardMediums, getCardMinMaxValues, stripGC } from 'lib/product';
import { CGProduct } from 'types/shopify';
import { Link as RouterLink } from 'react-router-dom';

interface ProductGridItemProps {
  product: CGProduct;
}

const ProductGridItem: React.FC<ProductGridItemProps> = ({ product }) => {
  //   console.debug(product);
  return (
    <Stack spacing={1} sx={{ mb: 5, textDecoration: 'none' }} component={RouterLink} to={`/product/${product.handle}`}>
      <CardMaster item={product} size="medium" noButton />
      <Stack spacing={0.75}>
        <Box
          sx={{
            typography: 'h6',
            lineHeight: {
              xs: '24px',
            },
          }}
        >
          {stripGC(product.title)}
        </Box>
        <Box
          sx={{
            typography: 'body1',
            color: 'text.secondary',
          }}
        >
          <ProductPriceRangeDisplay values={product?.options ? getCardMinMaxValues(product) : []} product={product} />
        </Box>
        <Box>
          <ProductMediumsIcon
            mediums={product?.options ? getCardMediums(product, true) : []}
            sx={{
              typography: 'body1',
              color: 'text.secondary',
              // verticalAlign: 'middle',
              // mr: 1,
            }}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ProductGridItem;
